module.exports = __webpack_public_path__ + "static/media/the_invisible_women_farmers_mobile.16ae4acf.jpg";